import { ArticleRangeClash } from '../numbering/ArticleRangeClash';
import { Box, Heading, Text } from '@chakra-ui/react';
import { createArticleStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';
import { ProposedArticleCard } from './ProposedArticleCard';
import { useCreateArticle } from './useCreateArticle';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';

export function CreateArticleProposals() {
  const { t } = useTranslation();
  const createArticle = useCreateArticle();
  const { expandedArticles, setExpandedArticles } = createArticle;
  return (
    <Box
      as="section"
      aria-label={t('article.create.proposed')}
      sx={styles.stack}
    >
      <Box>
        <Heading fontFamily="barlow" fontSize="xl">
          {t('article.create.proposed')}
        </Heading>
        <Text sx={styles.muted} mt={1}>
          {t('article.create.proposedHint')}
        </Text>
      </Box>
      {createArticle.availability.error && (
        <ErrorDetails error={createArticle.availability.error} />
      )}
      {createArticle.firstArticleClashes ? (
        <ArticleRangeClash
          mode={createArticle.mode}
          itemCode={createArticle.proposals[0].itemCode}
          suggestedRange={createArticle.suggestedRange}
          onApply={createArticle.applySuggestedRange}
        />
      ) : (
        <Box sx={styles.proposedList}>
          {createArticle.proposals.map((target, index) => (
            <ProposedArticleCard
              key={target.itemCode}
              {...target}
              isExpanded={expandedArticles[target.itemCode] ?? index === 0}
              onToggle={() =>
                setExpandedArticles((current) => ({
                  ...current,
                  [target.itemCode]: !(current[target.itemCode] ?? index === 0),
                }))
              }
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
